// extracted by mini-css-extract-plugin
export var label = "_dl-2";
export var slideContainer = "_dl-0";
export var slider = "_dl-1";